import styled from 'styled-components';
const SpinLoaderStyle = styled.div `
	--spinLoaderSize: var(--sp6x);
	--spinLoaderBorderSize: var(--sp1x);
	--spinLoaderBackground: #25b09b;
	--spinLoaderConicGradient: #0000 10%, #000;
	--spinLoaderLinearGradient: #000 0 0;
	--spinLoaderSpeed: 1s;

	&.spin-loader {
		width: var(--spinLoaderSize);
		padding: var(--spinLoaderBorderSize);
		aspect-ratio: 1;
		border-radius: 50%;
		background: var(--spinLoaderBackground);
		--_m: conic-gradient(var(--spinLoaderConicGradient)),
			linear-gradient(var(--spinLoaderLinearGradient)) content-box;
		-webkit-mask: var(--_m);
		mask: var(--_m);
		-webkit-mask-composite: source-out;
		mask-composite: subtract;
		animation: l3 var(--spinLoaderSpeed) infinite linear;
	}

	@keyframes l3 {
		to {
			transform: rotate(1turn);
		}
	}
`;
export default SpinLoaderStyle;
//# sourceMappingURL=style.js.map